import { IHttpService } from 'angular';
import { IInstanceSettings } from "../../typings/board/Models";
import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from "../instance-settings/instance-settings.service"

export const SHARED_STORAGE_SERVICE = "sharedStorageService";

export class SharedStorageService {

    static $inject = ["$http", INSTANCE_SETTINGS_SERVICE];
    constructor(private $http: IHttpService, private instanceSettingService: InstanceSettingsService) { }

    getSettings() {
        return this.instanceSettingService.getSettings().then((response) => { return response; });
    }

    dataDirectPassword(username: string, currentPassword: string, newPassword: string) {
        return this.instanceSettingService.dataDirectPassword(username, currentPassword, newPassword).then((response) => { return response; });
    }
}


// WEBPACK FOOTER //
// ./app/shared-storage/shared-storage.service.ts